/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import { v4 } from "uuid";
import { appendScript, appendStyle, getIcon } from "../../Components/Functions";
import { loggedUser } from "../../Constants/menus";
import { routers } from "../../Constants/routers";
import { updateSignup } from "../../Redux/Signup/actions";
import Api from "../../Server/Api";
import { UsernameSearch } from "../doctor/BecomeSpecialist";
import SuccessRegister from "./SuccessRegister";

const form = [
  { name: "first_name", icon: "user", type: "text", placeholder: "Firstname" },
  { name: "last_name", icon: "user", type: "text", placeholder: "Lastname" },
  { name: "email", icon: "mail", type: "email", placeholder: "Email" },
  { name: "password", icon: "lock", type: "password", placeholder: "Password" },
  // { name: "password_confirm", icon: "lock", type: "password", placeholder: "Password" },
];

const api = new Api();

const Register = (props) => {
  const [ploading, setpLoading] = React.useState(true);

  const [userType, setUserType] = React.useState(false);

  const [readTOC, setreadTOC] = React.useState(false);

  const [showUsername, setshowUsername] = React.useState(true);

  const [chosenCategories, setChosenCategories] = React.useState([]);

  const checkList = React.useRef(null);
  const checkBox = React.useRef(null);
  const updateSignup = (e) => {
    setUserType(e.role);
    e.role = e.role == "NURSE" ? "SPECIALIST" : e.role;
    props.updateSignup({ ...props?.signup, ...e });
  };
  function showCategories() {
    checkList.current.classList.remove("d-none");
  }
  function hideCategories() {
    checkList.current.classList.add("d-none");
  }
  function multiCheckList(e) {
    if (checkList.current.classList.contains("visible"))
      checkList.current.classList.remove("visible");
    // setChosen(oldArray => [...oldArray, newElement]);
    else checkList.current.classList.add("visible");
  }

  const validate = () => {
    const { username, first_name, last_name, email, password, role } =
      props?.signup || {};
    if (
      !username ||
      !first_name ||
      !last_name ||
      !email ||
      !password ||
      !role ||
      !readTOC
    )
      return false;
    return true;
  };

  const [success, setSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const _login = async () => {
    setLoading(true);
    const { username, first_name, last_name, email, password, role } =
      props?.signup || {};
    const data = { username, first_name, last_name, email, password, role };

    const res = await api.post({ endpoint: "/users/register/", data });
    if (res?.status) {
      setSuccess(true);
      if (["SPECIALIST", "NURSE"].includes(userType)) {
        for (let id of chosenCategories) {
          await api.put({
            endpoint: `/users/${username}/add_category/`,
            data: { id: parseInt(id) },
          });
        }
      }
    } else {
      notyf.open({
        type: "error",
        message:
          res?.detail ||
          res?.message ||
          "Unable to register your account at this time. Please try again later.",
      });
    }
    setLoading(false);
  };

  React.useEffect(() => {
    appendStyle("assets/css2/app.css");
    appendStyle("assets/css/app.css");
    appendStyle("assets/css/main.css");
    appendScript("assets/js/bundler2.js");

    appendScript("assets/js/functions.js");
    appendScript("assets/js/main.js");
    appendScript("assets/js/components.js");
    appendScript("assets/js/popover.js");
    appendScript("assets/js/widgets.js");
    appendScript("assets/js/touch.js");
    appendScript("assets/js/syntax.js");

    setTimeout(() => {
      setpLoading(false);
    }, 2000);

    if (loggedUser?.id > 0) window.location = routers.dashboard.base;
  }, []);

  const selected = {
    border: "2px solid #37514b",
    fontWeight: 900,
    color: "#37514b",
  };

  if (success) {
    return <SuccessRegister email={props?.signup?.email} />;
  }

  return (
    <>
      {ploading && (
        <>
          <div
            id="pageloader"
            className="pageloader is-left-to-right is-active"
          />
          <div id="infraloader" className="infraloader is-active" />
        </>
      )}
      <main>
        {/* Wrapper */}
        <div className="auth-wrapper columns is-gapless">
          {/* Form section */}
          <div className="column is-5">
            <div className="hero is-fullheight is-white">
              <div className="hero-heading">
                <div className="auth-logo">
                  <a href="/">
                    <img
                      className="top-logo"
                      src={require("../../assets/images/logo.png").default}
                      alt
                    />
                  </a>
                </div>
              </div>
              <div className="hero-body">
                <div className="container">
                  <div className="columns">
                    <div className="column is-12">
                      <div className="auth-content">
                        <h2>Join Us Now.</h2>
                        <p>Start by creating your account</p>
                        <a href={routers.auth.login}>
                          I already have an account{" "}
                        </a>
                      </div>
                      <div
                        className="auth-form-wrapper"
                        style={
                          showUsername
                            ? {
                                margin: 0,
                                maxWidth: "100%",
                              }
                            : {}
                        }
                      >
                        {/* Login Form */}
                        {(showUsername && (
                          <UsernameSearch
                            {...props}
                            callback={() => setshowUsername(false)}
                          />
                        )) || (
                          <form>
                            <div className="field">
                              <div className="control has-icon">
                                <input
                                  className="input"
                                  value={props?.signup?.username}
                                  readOnly
                                />
                                <span
                                  className="form-icon"
                                  dangerouslySetInnerHTML={{
                                    __html: getIcon("at-sign"),
                                  }}
                                ></span>
                                <span
                                  className="form-icon"
                                  style={{ right: 0, cursor: "pointer" }}
                                  dangerouslySetInnerHTML={{
                                    __html: getIcon("edit"),
                                  }}
                                  onClick={() => setshowUsername(true)}
                                ></span>
                              </div>
                            </div>
                            <div id="signin-form" className="login-form">
                              {/* Input */}
                              {form.map((field) => {
                                return (
                                  <div className="field">
                                    <div className="control has-icon">
                                      <input
                                        className="input"
                                        type={field.type}
                                        placeholder={field.placeholder}
                                        onInput={(e) =>
                                          updateSignup({
                                            [field.name]: e.target.value,
                                          })
                                        }
                                        defaultValue={props?.signup[field.name]}
                                      />
                                      <span
                                        className="form-icon"
                                        dangerouslySetInnerHTML={{
                                          __html: getIcon(field.icon),
                                        }}
                                      ></span>
                                    </div>
                                  </div>
                                );
                              })}
                              <div
                                class="d-none field control w-100 register-dropdown-check-list"
                                ref={checkList}
                                tabIndex="100"
                              >
                                <span
                                  class="input register-anchor"
                                  onClick={multiCheckList}
                                >
                                  Select Categories
                                </span>
                                <ul class="items">
                                  {props.categories.map((item) => (
                                    <li data-id={item.id}>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          checkList.current
                                            .querySelectorAll(
                                              `li[data-id="${item.id}"] input`
                                            )[0]
                                            .click();
                                        }}
                                        class="input"
                                      >
                                        <input
                                          type="checkbox"
                                          data-id={item.id}
                                          onClick={(e) => {
                                            let id =
                                              e.target.getAttribute("data-id");
                                            if (e.target.checked) {
                                              setChosenCategories(
                                                (oldArray) => [...oldArray, id]
                                              );
                                            } else {
                                              setChosenCategories(
                                                chosenCategories.filter(
                                                  (item) => item !== id
                                                )
                                              );
                                            }
                                            e.stopPropagation();
                                          }}
                                        />
                                        <span>{item.title}</span>
                                      </button>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="buttons">
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    hideCategories();
                                    updateSignup({ role: "PATIENT" });
                                  }}
                                  className="button is-raised-hover mx-1"
                                  style={{
                                    width: "calc(32% - 0.5rem)",
                                    ...(userType === "PATIENT" ? selected : {}),
                                  }}
                                >
                                  Patient
                                </a>
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    showCategories();
                                    updateSignup({ role: "SPECIALIST" });
                                  }}
                                  className="button is-heavy mx-1"
                                  style={{
                                    width: "calc(32% - 0.5rem)",
                                    ...(userType === "SPECIALIST"
                                      ? selected
                                      : {}),
                                  }}
                                >
                                  Specialist
                                </a>
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    showCategories();
                                    updateSignup({ role: "NURSE" });
                                  }}
                                  className="button is-heavy mx-1"
                                  style={{
                                    width: "calc(32% - 0.5rem)",
                                    ...(userType === "NURSE" ? selected : {}),
                                  }}
                                >
                                  Nurse
                                </a>
                              </div>

                              <div className="setting-item">
                                <label className="form-switch is-primary">
                                  <input
                                    type="checkbox"
                                    className="is-switch"
                                    onChange={(e) =>
                                      setreadTOC(e.target.checked)
                                    }
                                    defaultChecked={readTOC}
                                  />
                                  <i />
                                </label>
                                <div className="setting-meta">
                                  <span>
                                    I have read and agree to the{" "}
                                    <a
                                      href={routers.pages.tos}
                                      target="_blank"
                                      style={{ color: "#37514b" }}
                                    >
                                      Terms of Service.
                                    </a>
                                  </span>
                                </div>
                              </div>
                              {/* Submit */}
                              {validate() && (
                                <div className="control login">
                                  <button
                                    className={`button h-button is-primary is-bold is-fullwidth is-raised ${
                                      loading ? "is-loading" : ""
                                    }`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      _login();
                                    }}
                                  >
                                    Sign Up
                                  </button>
                                </div>
                              )}
                            </div>
                          </form>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Image section (hidden on mobile) */}
          <div className="column login-colum is-7 is-hidden-mobile h-hidden-tablet-p hero-banner">
            <div
              className="hero login-hero is-fullheight is-app-grey"
              data-background="https://dummyimage.com/1920x1080"
              style={{
                transform: "scaleX(-1)",
                backgroundImage: `url("${
                  require("../../assets/images/pexels-karolina-grabowska-4386466.jpg")
                    .default
                }")`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <div className="hero-body" />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

const mapStateToProps = ({ signup, categories }) => {
  return {
    signup,
    categories: categories.allcategories.sort(function compare(a, b) {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title > b.title) {
        return 1;
      }
      return 0;
    }),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateSignup: (e) => dispatch(updateSignup(e)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
